/* OUNCE ORIGINALS — global behaviours */
(function () {
  'use strict';

  /* ----- Mobile menu drawer ----- */
  var drawer = document.getElementById('MenuDrawer');
  document.querySelectorAll('[data-menu-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!drawer) return;
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      btn.setAttribute('aria-expanded', 'true');
    });
  });
  document.querySelectorAll('[data-menu-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      document.querySelectorAll('[data-menu-open]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  /* ----- Collection: facet form auto-submit + mobile drawer ----- */
  var facetForm = document.getElementById('FacetsForm');
  if (facetForm) {
    facetForm.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      input.addEventListener('change', function () { facetForm.submit(); });
    });
    facetForm.querySelectorAll('input[type="number"]').forEach(function (input) {
      input.addEventListener('change', function () { facetForm.submit(); });
    });
  }
  document.querySelectorAll('[data-facets-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (facetForm) { facetForm.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    });
  });
  document.querySelectorAll('[data-facets-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (facetForm) { facetForm.classList.remove('is-open'); document.body.style.overflow = ''; }
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && facetForm && facetForm.classList.contains('is-open')) {
      facetForm.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  /* ----- Sort select ----- */
  var sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ----- Carousels ----- */
  document.querySelectorAll('[data-carousel]').forEach(function (wrap) {
    var track = wrap.querySelector('.carousel');
    if (!track) return;
    var step = function () {
      var first = track.firstElementChild;
      return first ? first.getBoundingClientRect().width + 24 : 320;
    };
    wrap.querySelectorAll('[data-carousel-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    });
    wrap.querySelectorAll('[data-carousel-next]').forEach(function (btn) {
      btn.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  });

  /* ----- Product gallery: click thumb to swap main image ----- */
  var mainImage = document.querySelector('[data-gallery-main] img');
  if (mainImage) {
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var img = thumb.querySelector('img');
        if (!img) return;
        var full = img.getAttribute('data-full') || img.src;
        mainImage.src = full;
        if (img.alt) mainImage.alt = img.alt;
      });
    });
  }

  /* ----- Reviews wall filter chips ----- */
  var chipWrap = document.querySelector('[data-review-filters]');
  if (chipWrap) {
    chipWrap.querySelectorAll('.filter-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        chipWrap.querySelectorAll('.filter-chip').forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        var filter = chip.getAttribute('data-filter');
        document.querySelectorAll('[data-review-item]').forEach(function (item) {
          var tags = (item.getAttribute('data-tags') || '').split(',');
          var show = filter === 'all' || tags.indexOf(filter) !== -1;
          item.style.display = show ? '' : 'none';
        });
      });
    });
  }
})();
